module.exports = __webpack_public_path__ + "static/media/calls.f2eb27f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/calls.svg
// module id = 869
// module chunks = 0